import get from 'lodash/get';

import { l10n } from '@ott/l10n';

import { ErrorData } from '../redux/auth/types';

const parseError = (errorData: ErrorData) => {
  switch ((typeof errorData !== 'string' && errorData.error) || errorData) {
    case 'EMAIL_NOT_VALID':
      return l10n('auth.emailFormat');
    case 'PWD_NOT_CONFIRMED':
      return l10n('auth.passwordsNotEqual');
    case 'PWD_TOO_SHORT':
      return l10n('auth.passwordShort');
    case 'PWD_EMPTY_OR_TOO_SMALL':
      return l10n('auth.passwordShort');
    case 'INVALID_PASSWORD':
    case 'INVALID_LOGIN':
    case 'WRONG_PWD_OR_EMAIL':
      return l10n('auth.wrongData');
    case 'NOT_REGISTERED':
      return l10n('auth.notRegistered');
    case 'EMAIL_EXISTS':
    case 'USER_ALREADY_EXIST': {
      const email = get(errorData, 'customerInfo.params.email', '');
      return l10n('auth.alreadyHas', { email });
    }
    case 'LIMIT_REACHED':
      return l10n('auth.limitReached');
    case 'TOO_MANY_TRIES':
      return l10n('auth.tooManyTries');
    case 'PHONE_NOT_REGED':
      return l10n('auth.phoneNotReged');
    case 'WEAK_PASSWORD':
      return l10n('auth.weakPassword');
    default:
      return l10n('errors.SYSTEM_ERROR.text');
  }
};

export default parseError;
